import React from 'react'
import { Container, Row, Spinner } from 'react-bootstrap'

export function Loading(){
    return (
        <>
        <Container className="h-100">
            <Row className="justify-content-center">
                <Spinner animation="border" variant="info"/>
            </Row>
        </Container>
        </>
    )
}